import moment from "moment-timezone";
const makeappointmentState = {
  madeappointment:[],
  onlineappointment:{}

};
export const makeappointmentReducer = (state = makeappointmentState, action: any) => {
  switch (action.type) {
    case "GET_ONLINE_APPOINTMENT":
      return {
        ...state,
        onlineappointment: action.payload,
      };
   

   
    default:
      return state;
  }
};
